import { CheckCircleFilled, MailOutlined, PhoneOutlined } from "@ant-design/icons";
import { Card, Col, Flex, List, Row, Typography } from "antd";
import { Content } from "antd/es/layout/layout";
import { useSearchParams } from "react-router-dom";
import { openNotification } from "../../Components/Notification";
import "./index.scss";
import SignUpForm from "./SignUpForm";

const SignUp = () => {
  const [searchParams] = useSearchParams();
  const screeningSessionId = searchParams.get("screening_session_id");
  const isScreeningContext = Boolean(screeningSessionId);

  const steps = [
    "We'll reach out to set up your assessment",
    "You review and launch it",
    "Candidates apply & get scored instantly",
    "You get a shortlist + interview support",
    "You make your hire 🎉",
  ];

  const screeningSteps = [
    "Securely save and track all your screening reports",
    "AI-based dynamic assessments for skill validation",
    "Invite your team to collaborate on candidate evaluation",
    "Automated candidate ranking and shortlisting",
    "No credit card required — get started in minutes",
  ];

  const handleEmailClick = () => {
    const email = "support@qualifyme.ai";
    const subject = "Support Request";
    const mailtoLink = `mailto:${email}?subject=${encodeURIComponent(subject)}`;

    let mailClientLikelyOpened = false;

    const handleBlur = () => {
      mailClientLikelyOpened = true;
      window.removeEventListener("blur", handleBlur);
    };

    window.addEventListener("blur", handleBlur);

    window.location.href = mailtoLink;

    setTimeout(() => {
      window.removeEventListener("blur", handleBlur);

      if (!mailClientLikelyOpened) {
        const fallbackGmailLink = `https://mail.google.com/mail/?view=cm&to=${email}&su=${encodeURIComponent(
          subject
        )}`;
        const newTab = window.open(fallbackGmailLink, "_blank");

        if (newTab) {
          newTab.focus();
        } else {
          openNotification(
            "warning",
            "Blocker detected",
            `Please allow pop-ups for this site or visit email app  and send email to ${email}.`
          );
        }
      }
    }, 750);
  };

  return (
    <Content className="sign-up__content-wrapper">
      <Row wrap className="sign-up">
        {/* Left Content */}
        <Col xs={24} md={14} className="sign-up__content">
          <Flex vertical gap={32} align="start" justify="space-between">
            <img
              src="/images/qualifyme-text-logo.png"
              alt="QualifyMe"
              className="sign-up__logo"
            />
            <section className="sign-up__header-section">
              {isScreeningContext ? (
                <Flex vertical>
                  <Typography.Title level={2} className="sign-up__main-title">
                    Save Your Progress &{" "}
                    <span className="sign-up__orange-text">
                      Unlock Full Insights.
                    </span>
                  </Typography.Title>
                  <Typography.Text className="sign-up__description">
                    You've successfully analyzed 1 candidate with our free
                    Profile Matching tool. Sign up to unlock the full
                    experience.
                  </Typography.Text>
                  <List
                    size="small"
                    bordered={false}
                    dataSource={screeningSteps}
                    renderItem={(item) => (
                      <List.Item className="sign-up__step-item">
                        <CheckCircleFilled className="sign-up__step-icon" />
                        <Typography.Text className="sign-up__step-text">
                          {item}
                        </Typography.Text>
                      </List.Item>
                    )}
                  />
                </Flex>
              ) : (
                <Flex vertical>
                  <Typography.Title level={2} className="sign-up__main-title">
                    You're just a step away from <br />
                    <span className="sign-up__orange-text">
                      Smarter Hiring.
                    </span>
                  </Typography.Title>
                  <Typography.Text className="sign-up__description">
                    Set up your first role with full support — no credit card, no
                    commitments. We'll handle everything and guide you through
                    your first hire.
                  </Typography.Text>
                  <Typography.Title level={5} className="sign-up__next-title">
                    <strong>What Happens After You Sign Up?</strong>
                  </Typography.Title>
                  <List
                    size="small"
                    bordered={false}
                    dataSource={steps}
                    renderItem={(item) => (
                      <List.Item className="sign-up__step-item">
                        <CheckCircleFilled className="sign-up__step-icon" />
                        <Typography.Text className="sign-up__step-text">
                          {item}
                        </Typography.Text>
                      </List.Item>
                    )}
                  />
                </Flex>
              )}
            </section>
            <Typography.Title level={5} className="sign-up__next-title">
              Need help or want to talk first?
              <br />
              <a
                href="#"
                className="sign-up__email-link"
                onClick={(e) => {
                  e.preventDefault();
                  handleEmailClick();
                }}
              >
                <MailOutlined />&nbsp;
                support@qualifyme.ai
              </a>
              <span className="sign-up__contact-divider">|</span>
              <a
                href="tel:+919739948887"
                className="sign-up__phone-link"
              >
                <PhoneOutlined /> +91 97399 48887
              </a>
            </Typography.Title>
          </Flex>
        </Col>
        {/* Right Form */}
        <Col xs={24} md={10} className="sign-up__form">
          <div className="sign-up__form-inner">
            <Card
              bordered={false}
              className="sign-up__form-card"
              title={
                <Typography.Title level={4} className="sign-up__form-title">
                  Sign Up
                </Typography.Title>
              }
            >
              <SignUpForm />
            </Card>
          </div>
        </Col>
      </Row>
    </Content>
  );
};

export default SignUp;
